"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StasisAbilityHandler = exports.StasisActorAbilityFactory = exports.StasisAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class StasisAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Stasis;
        this.__typeName = "Stasis";
    }
}
exports.StasisAbilityArgs = StasisAbilityArgs;
let StasisActorAbilityFactory = class StasisActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Stasis", "Any", 5);
    }
};
StasisActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Stasis")
], StasisActorAbilityFactory);
exports.StasisActorAbilityFactory = StasisActorAbilityFactory;
let StasisAbilityHandler = class StasisAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated: sequence => {
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId,
                    amount: container.getPercentOfMaxHealth(targetId, 50),
                    onApplied: sequence => {
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId,
                            duration: Duration_1.Duration.Turns(2),
                            supernatural: true,
                            effect: new core_1.LinkedEffectsEffectArgs([
                                new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AbsoluteAllDamageImmunity, 100),
                                new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingReceivedDecrease, 100),
                                new core_1.StunEffectArgs(),
                                new core_1.CharmImmunityEffectArgs()
                            ], false),
                            onApplied: sequence => sequence
                                .push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "OverlappingTimeCircles"))
                        });
                    }
                });
            }
        });
    }
};
StasisAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Stasis)
], StasisAbilityHandler);
exports.StasisAbilityHandler = StasisAbilityHandler;
